import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ImprimeTicketComponent } from '../../imprime-ticket/imprime-ticket.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as moment from 'moment';

import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
import { CancelaTicketComponent } from 'src/app/cancela-ticket/cancela-ticket.component';
import { EditaFormaComponent } from 'src/app/edita-forma/edita-forma.component';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const MY_FORMATS = {
  parse: {
    dateInput: 'L', 
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-ultimos-tickets',
  templateUrl: './ultimos-tickets.component.html',
  styleUrls: ['./ultimos-tickets.component.css'],
  providers: [
    { provide: MatDialogRef,useValue: {} },
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    {provide: MAT_DATE_LOCALE, useValue: "es-MX" },
  ] 
})
export class UltimosTicketsComponent implements OnInit {
  errMsg:any;
  tickets:any=[];
  roles:any=[];
  prods:any=[];
  descs:any=[];
  users:any=[];
  loading:boolean=false;
  fecIni:any = moment();
  fecFin:any = moment();
  usr:string="0";
  gpo:any=[];
  origenes:any=[];
  idGpo:number=0;
  formato:any=[];
  formStyle:any[];
  elemImp:any[];
  elemStyle:any[]=[]  
  dd:any;
  infoReciboTienda:any=[];
  grls:any;
  agruparTickets:boolean = true;
  separaFolio:boolean=false;
  info:any=[];
  
  thisForm = new FormGroup({
    usr: new FormControl(this.usr == "0" ? 0 : this.usr, []),
    gpo: new FormControl(this.idGpo, []),
    separaFolio: new FormControl(this.separaFolio, []),
  });


  constructor(private dataService: DataService, public dialogRef: MatDialogRef<ImprimeTicketComponent>, public dialog: MatDialog) { }

  ngOnInit() {
    this.loading = true;
    //----->>>>>>>>>>
    this.dataService.getG().subscribe(
                      rows => {   
                              this.grls = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnGrlsCargados()); 
    this.dataService.getGrupos().subscribe(
                      rows => {   
                              this.gpo = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnGruposCargados());
    /* --> Todos los origenes de ingresos en selector
    this.dataService.getOrigenes('1').subscribe(
                      rows => {   
                              this.origenes = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnOrigenesCargados());
    */
    this.dataService.getUsuarios('%').subscribe(
                      rows => {   
                              this.users = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnUsuariosCargados());
    this.dataService.getFormatoImp(1, 1).subscribe(
                      rows => {   
                              this.formato = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFormatoImpCargado());                      

  }

  fnGrlsCargados(){
    //console.log (this.grls);
    if(this.grls){
      if(this.grls[0]){
        if(this.grls[0].n){
          this.dataService.sN = this.grls[0].n;
          //this.sysN = this.grls[0].n;
        }
        if(this.grls[0].we)
          this.dataService.sWe = this.grls[0].we;
        if(this.grls[0].m)
          this.dataService.sM = this.grls[0].m;
        if(this.grls[0].t1)
          this.dataService.sT1 = this.grls[0].t1;
        if(this.grls[0].t2)
          this.dataService.sT2 = this.grls[0].t2;
        if(this.grls[0].wa)
          this.dataService.sWa = this.grls[0].wa;
        if(this.grls[0].di)
          this.dataService.sDi = this.grls[0].di;
        if(this.grls[0].di2)
          this.dataService.sDi2 = this.grls[0].di2;
        if(this.grls[0].terr){
          this.dataService.sTerr = this.grls[0].terr;
        }
        if(this.grls[0].ip)
          this.dataService.sIP = this.grls[0].ip;
        if(this.grls[0].rfc)
          this.dataService.sRFC = this.grls[0].rfc;
        if(this.grls[0].cp)
          this.dataService.sCP = this.grls[0].cp;

      }
    }
  }

  fnGruposCargados(){
    //console.log(this.gpo);
  }

  fnOrigenesCargados(){
    //console.log(this.origenes);
  }

  fnUsuariosCargados(){
    //console.log(this.users);
    this.dataService.getRoles().subscribe(
                      rows => {   
                              this.roles = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnRolesCargados());
}

  fnRolesCargados(){
    //console.log(this.roles);
    this.dataService.getDescuentos(-1).subscribe(
                      rows => {   
                              this.descs = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnDescuentosCargados());
  }

  fnDescuentosCargados(){
    //console.log(this.descs);
    this.dataService.getProductos().subscribe(
                      rows => {   
                              this.prods = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnProductosCargados());
  }

  fnProductosCargados(){
    //console.log(this.prods);
    this.fnCargaReporte();
  }

  fnCargaReporte(){
    this.info = null;
    if(this.separaFolio){
      this.dataService.ultTickets(this.usr, '%', this.fecIni.format("YYYYMMDD"), this.fecFin.format("YYYYMMDD"), this.idGpo, '-2,-1,0,1,2').subscribe(
                                  rows => {   
                                          this.tickets = <any>rows
                                          },          
                                  error => this.errMsg = <any>error,
                                  () => this.fnTicketsCargados());
    }
    else{
      this.dataService.ultTicketsGpo(this.usr, '%', this.fecIni.format("YYYYMMDD"), this.fecFin.format("YYYYMMDD"), this.idGpo, '-2,-1,0,1,2').subscribe(
                                  rows => {   
                                          this.tickets = <any>rows
                                          },          
                                  error => this.errMsg = <any>error,
                                  () => this.fnTicketsCargados());
    }
  }

  fnTicketsCargados(){
    var gpo1NumFolios = 0;
    var gpo1Total = 0;
    var gpo1Cancelados = 0;
    var gpo1FolioIni = -1;
    var gpo1FolioFin = -1;
    var gpo1ReciboIni = -1;
    var gpo1ReciboFin = -1;

    var gpo2NumFolios = 0;
    var gpo2Total = 0;
    var gpo2Cancelados = 0;
    var gpo2FolioIni = -1;
    var gpo2FolioFin = -1;
    var gpo2ReciboIni = -1;
    var gpo2ReciboFin = -1;

    var gpo3NumFolios = 0;
    var gpo3Total = 0;
    var gpo3Cancelados = 0;
    var gpo3FolioIni = -1;
    var gpo3FolioFin = -1;
    var gpo3ReciboIni = -1;
    var gpo3ReciboFin = -1;

    var gpo4NumFolios = 0;
    var gpo4Total = 0;
    var gpo4Cancelados = 0;
    var gpo4FolioIni = -1;
    var gpo4FolioFin = -1;
    var gpo4ReciboIni = -1;
    var gpo4ReciboFin = -1;

    var gpo991NumFolios = 0;
    var gpo991Total = 0;
    var gpo991Cancelados = 0;
    var gpo991FolioIni = -1;
    var gpo991FolioFin = -1;
    var gpo991ReciboIni = -1;
    var gpo991ReciboFin = -1;

    var gpo999NumFolios = 0;
    var gpo999Total = 0;
    var gpo999Cancelados = 0;
    var gpo999FolioIni = -1;
    var gpo999FolioFin = -1;
    var gpo999ReciboIni = -1;
    var gpo999ReciboFin = -1;

    var auxTotFolios = 0;
    var auxTotOp = 0;

    this.info = [];
    for(var i = 0; i < this.tickets.length; i++){
      if(this.agruparTickets){
        auxTotFolios += this.tickets[i].n;
        auxTotOp++;
      }
      else{
        auxTotFolios++;
        if(this.tickets[i].i == 1)
        auxTotOp++;
      }

      if(this.tickets[i].idGpo == 1 && this.tickets[i].idProd < 99990){
        if(this.agruparTickets){
          gpo1NumFolios += this.tickets[i].n;
          if(this.tickets[i].stat < 0)
            gpo1Cancelados += this.tickets[i].n;
          else
            gpo1Total += this.tickets[i].tot
        }
        else{
          gpo1NumFolios++;
          if(this.tickets[i].stat < 0)
            gpo1Cancelados++;
          else
            gpo1Total += this.tickets[i].tot;        
        }
        if(gpo1FolioIni < 0 || gpo1FolioIni > this.tickets[i].folio)
          gpo1FolioIni = this.tickets[i].folio
        if(gpo1FolioFin < this.tickets[i].folio)
          gpo1FolioFin = this.tickets[i].folio
        if(gpo1ReciboIni < 0 || (this.tickets[i].folioGpo > 0 && gpo1ReciboIni > this.tickets[i].folioGpo))
          gpo1ReciboIni = this.tickets[i].folioGpo
        if(gpo1ReciboFin < this.tickets[i].folioGpo)
          gpo1ReciboFin = this.tickets[i].folioGpo
      }
      if(this.tickets[i].idGpo == 2 && this.tickets[i].idProd < 99990){
        if(this.agruparTickets){
          gpo2NumFolios += this.tickets[i].n;
          if(this.tickets[i].stat < 0)
            gpo2Cancelados += this.tickets[i].n;
          else
            gpo2Total += this.tickets[i].tot
        }
        else{
          gpo2NumFolios++;
          if(this.tickets[i].stat < 0)
            gpo2Cancelados++;
          else
            gpo2Total += this.tickets[i].tot;        
        }
        if(gpo2FolioIni < 0 || gpo2FolioIni > this.tickets[i].folio)
          gpo2FolioIni = this.tickets[i].folio
        if(gpo2FolioFin < this.tickets[i].folio)
          gpo2FolioFin = this.tickets[i].folio
        if(gpo2ReciboIni < 0 || (this.tickets[i].folioGpo > 0 && gpo2ReciboIni > this.tickets[i].folioGpo))
          gpo2ReciboIni = this.tickets[i].folioGpo
        if(gpo2ReciboFin < this.tickets[i].folioGpo)
          gpo2ReciboFin = this.tickets[i].folioGpo
      }
      if(this.tickets[i].idGpo == 3 && this.tickets[i].idProd < 99990){
        if(this.agruparTickets){
          gpo3NumFolios += this.tickets[i].n;
          if(this.tickets[i].stat < 0)
            gpo3Cancelados += this.tickets[i].n;
          else
            gpo3Total += this.tickets[i].tot
        }
        else{
          gpo3NumFolios++;
          if(this.tickets[i].stat < 0)
            gpo3Cancelados++;
          else
            gpo3Total += this.tickets[i].tot;        
        }
        if(gpo3FolioIni < 0 || gpo3FolioIni > this.tickets[i].folio)
          gpo3FolioIni = this.tickets[i].folio
        if(gpo3FolioFin < this.tickets[i].folio)
          gpo3FolioFin = this.tickets[i].folio
        if(gpo3ReciboIni < 0 || (this.tickets[i].folioGpo > 0 && gpo3ReciboIni > this.tickets[i].folioGpo))
          gpo3ReciboIni = this.tickets[i].folioGpo
        if(gpo3ReciboFin < this.tickets[i].folioGpo)
          gpo3ReciboFin = this.tickets[i].folioGpo
      }
      if(this.tickets[i].idGpo == 4 && this.tickets[i].idProd < 99990){
        if(this.agruparTickets){
          gpo4NumFolios += this.tickets[i].n;
          if(this.tickets[i].stat < 0)
            gpo4Cancelados += this.tickets[i].n;
          else
            gpo4Total += this.tickets[i].tot
        }
        else{
          gpo4NumFolios++;
          if(this.tickets[i].stat < 0)
            gpo4Cancelados++;
          else
            gpo4Total += this.tickets[i].tot;        
        }
        if(gpo4FolioIni < 0 || gpo4FolioIni > this.tickets[i].folio)
          gpo4FolioIni = this.tickets[i].folio
        if(gpo4FolioFin < this.tickets[i].folio)
          gpo4FolioFin = this.tickets[i].folio
        if(gpo4ReciboIni < 0 || (this.tickets[i].folioGpo > 0 && gpo4ReciboIni > this.tickets[i].folioGpo))
          gpo4ReciboIni = this.tickets[i].folioGpo
        if(gpo4ReciboFin < this.tickets[i].folioGpo)
          gpo4ReciboFin = this.tickets[i].folioGpo

      }
      if(this.tickets[i].idProd == 99991){
        if(this.agruparTickets){
          gpo991NumFolios += this.tickets[i].n;
          if(this.tickets[i].stat < 0)
            gpo991Cancelados += this.tickets[i].n;
          else
            gpo991Total += this.tickets[i].tot
        }
        else{
          gpo991NumFolios++;
          if(this.tickets[i].stat < 0)
            gpo991Cancelados++;
          else
            gpo991Total += this.tickets[i].tot;        
        }
        if(gpo991FolioIni < 0 || gpo991FolioIni > this.tickets[i].folio)
          gpo991FolioIni = this.tickets[i].folio
        if(gpo991FolioFin < this.tickets[i].folio)
          gpo991FolioFin = this.tickets[i].folio
        if(gpo991ReciboIni < 0 || (this.tickets[i].folioGpo > 0 && gpo991ReciboIni > this.tickets[i].folioGpo))
          gpo991ReciboIni = this.tickets[i].folioGpo
        if(gpo991ReciboFin < this.tickets[i].folioGpo)
          gpo991ReciboFin = this.tickets[i].folioGpo
      }
      if(this.tickets[i].idProd > 99991){   //--> TODOS LOS INGRESOS (EXCEPTO TIENDA)
        if(this.agruparTickets){
          gpo999NumFolios += this.tickets[i].n;
          if(this.tickets[i].stat < 0)
            gpo999Cancelados += this.tickets[i].n;
          else
            gpo999Total += this.tickets[i].tot
        }
        else{
          gpo999NumFolios++;
          if(this.tickets[i].stat < 0)
            gpo999Cancelados++;
          else
            gpo999Total += this.tickets[i].tot;        
        }
        if(gpo999FolioIni < 0 || gpo999FolioIni > this.tickets[i].folio)
          gpo999FolioIni = this.tickets[i].folio
        if(gpo999FolioFin < this.tickets[i].folio)
          gpo999FolioFin = this.tickets[i].folio
        if(gpo999ReciboIni < 0 || (this.tickets[i].folioGpo > 0 && gpo999ReciboIni > this.tickets[i].folioGpo))
          gpo999ReciboIni = this.tickets[i].folioGpo
        if(gpo999ReciboFin < this.tickets[i].folioGpo)
          gpo999ReciboFin = this.tickets[i].folioGpo
      }
    
      if(this.tickets[i].idDesc >= 0 && this.tickets[i].idDesc < 99){
        var auxDesc = this.dataService.findItemInObject(this.descs, this.tickets[i].idDesc, "id");
        var auxAux = "";
        try{
          auxAux = auxDesc.descuento;
        }
        catch{

        }
        this.tickets[i].aplicaDescuento = " (" + auxAux + ")";
      }
      this.tickets[i].usuario = this.dataService.findItemInObject(this.users, this.tickets[i].idUsuario, "idUsuario").nombre;
    }
    this.info.push({ 'totOperaciones':auxTotOp,
                     'totFolios': auxTotFolios,  
                     'Taquilla': {'numFolios':gpo1NumFolios, 'folioIni':gpo1FolioIni, 'folioFin':gpo1FolioFin, 'reciboIni':gpo1ReciboIni, 'reciboFin':gpo1ReciboFin, 'cancelados':gpo1Cancelados, 'total':gpo1Total },
                     'DesInst': {'numFolios':gpo2NumFolios, 'folioIni':gpo2FolioIni, 'folioFin':gpo2FolioFin, 'reciboIni':gpo2ReciboIni, 'reciboFin':gpo2ReciboFin, 'cancelados':gpo2Cancelados, 'total':gpo2Total },
                     'Volun': {'numFolios':gpo3NumFolios, 'folioIni':gpo3FolioIni, 'folioFin':gpo3FolioFin, 'reciboIni':gpo3ReciboIni, 'reciboFin':gpo3ReciboFin, 'cancelados':gpo3Cancelados, 'total':gpo3Total },
                     'SerPed':{'numFolios':gpo4NumFolios, 'folioIni':gpo4FolioIni, 'folioFin':gpo4FolioFin, 'reciboIni':gpo4ReciboIni, 'reciboFin':gpo4ReciboFin, 'cancelados':gpo4Cancelados, 'total':gpo4Total },
                     'Tienda':{'numFolios':gpo991NumFolios, 'folioIni':gpo991FolioIni, 'folioFin':gpo991FolioFin, 'reciboIni':gpo991ReciboIni, 'reciboFin':gpo991ReciboFin, 'cancelados':gpo991Cancelados, 'total':gpo991Total },
                     'Otros':{'numFolios':gpo999NumFolios, 'folioIni':gpo999FolioIni, 'folioFin':gpo999FolioFin, 'reciboIni':gpo999ReciboIni, 'reciboFin':gpo999ReciboFin, 'cancelados':gpo999Cancelados, 'total':gpo999Total },
                  });
    console.log(this.info);                  
    this.loading = false;
  }
  
  fnFormatoImpCargado(){
    //console.log("Formatos: ");
    //console.log(this.formato);
    var arrIdForms = [];
    for(var i = 0; i < this.formato.length; i++){
      arrIdForms.push(this.formato[i].id);
    }
    //--> Obtener styles
    this.dataService.getFormStyles(arrIdForms.join(","), "1,2").subscribe(
                rows => {   
                        this.formStyle = <any>rows
                        },          
                error => this.errMsg = <any>error,
                () => this.fnFormStyleCargado())
  }

  fnFormStyleCargado(){
    //console.log(this.formStyle)
    var arrStyles=[];
    for(var i = 0; i < this.formStyle.length; i++){
      arrStyles.push(this.formStyle[i].style);
    }
    arrStyles = arrStyles.filter(this.dataService.onlyUnique);        
    for(var i = 0; i < arrStyles.length; i++){
      this.elemStyle[arrStyles[i]] = {};
      for(var k = 0; k < this.formStyle.length; k++){
        if(arrStyles[i] == this.formStyle[k].style){
            var auxObj = Object.keys(this.elemStyle[arrStyles[i]]);
            //console.log("Keys of Object:");
            //console.log(auxObj);
            if(auxObj.length == 0)
              this.elemStyle[arrStyles[i]] = {[this.formStyle[k].key]:this.formStyle[k].valor} ;
            else
              this.elemStyle[arrStyles[i]][this.formStyle[k].key]   = this.formStyle[k].valor;
        }
      }
    }
    //console.log(this.elemStyle);
  }

  
  onChange(idEl, item, tipo){
    //console.log("onChange: " + tipo)
    this.onClick(idEl,item,tipo);
  }

  onClick(idEl, item, tipo){
    //console.log(tipo);
    //console.log("onClick: " + idEl);
    //console.log(item);
    if(tipo=="GPO"){
      this.idGpo = idEl;
      this.thisForm.controls["gpo"].setValue(this.idGpo);
    }   

    if(tipo=="USER"){
      this.usr = idEl;
      //console.log(this.usr)
      if(this.usr=='%')
        this.thisForm.controls["usr"].setValue(0);
      else
        this.thisForm.controls["usr"].setValue(this.usr);
    }   
    this.fnCargaReporte()
  }
  
  fnCambiaFecha(tipo, obj){
    this.loading = true;
    if (tipo=="INI"){
      this.fecIni = moment(obj.value.format("YYYYMMDD"));
    }
    if (tipo=="FIN"){
      this.fecFin = moment(obj.value.format("YYYYMMDD"));
    }
    this.fnCargaReporte();
  }

  fnImprimir(ticket){
    //console.log("imprimir: " + ticket.id);
    let dialogRef = this.dialog.open(ImprimeTicketComponent, {
                      width: "600px",
                      data: { 
                            id:ticket.id,
                            item:ticket,
                            grupo:this.agruparTickets
                            }
                    });
    dialogRef.afterClosed().subscribe(result => {
                    //console.log("Popup cerrado");
                    }); 
  }

  fnImprimirRecibo(ticket){
    var folio = ticket.folio - ticket.i + 1;
    var folioFin = folio + ticket.n - 1;
    console.log(ticket.idProd);
    if(ticket.idProd > 99990){
      this.dataService.getInfoReciboOrigen(folio, folioFin).subscribe(
                              rows => {   
                                      this.infoReciboTienda = <any>rows
                                      },          
                              error => this.errMsg = <any>error,
                              () => this.fnInfoRecibosOrigenes(ticket, folio, folioFin));       
    }
    else{
      this.dataService.insLog(41, 'IMPRIMIR', "RECIBO", folio != folioFin ? folio + " al " + folioFin : folio).subscribe(
                              row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
      this.dataService.getElemFormatoImp(9, "'CONTENT', 'COLUMN', 'CELL', 'NEW_LINE', 'NEW_ROW', 'STYLE', 'POSITION', 'LINE', 'RECT', 'ELLIPSE', 'END DRAW', 'IMAGE', 'GRAF1', 'GRAF2', 'GRAF3', 'GRAF4'", "1,2").subscribe(
                              rows => {   
                                      this.elemImp = <any>rows
                                      },          
                              error => this.errMsg = <any>error,
                              () => this.fnElementosImpresionReciboCargados(9, folio, folioFin, ticket));              
    }
  }

  fnInfoRecibosOrigenes(ticket, folio, folioFin){
    console.log(this.infoReciboTienda)
    this.dataService.insLog(41, 'IMPRIMIR', "RECIBO INGRESO", folio != folioFin ? folio + " al " + folioFin : folio).subscribe(
                            row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
    this.dataService.getElemFormatoImp(9, "'CONTENT', 'COLUMN', 'CELL', 'NEW_LINE', 'NEW_ROW', 'STYLE', 'POSITION', 'LINE', 'RECT', 'ELLIPSE', 'END DRAW', 'IMAGE', 'GRAF1', 'GRAF2', 'GRAF3', 'GRAF4'", "1,2").subscribe(
                            rows => {   
                                    this.elemImp = <any>rows
                                    },          
                            error => this.errMsg = <any>error,
                            () => this.fnElementosImpresionReciboCargados(9, folio, folioFin, ticket));              
  }

  fnClickDes(elem:any){
    setTimeout(() => {
      //console.log(this.thisForm.controls["separaDia"].value);
      if(this.thisForm.controls["separaFolio"].value){
        this.separaFolio = true;
        this.agruparTickets = false;
      } 
      else{
        this.separaFolio = false;
        this.agruparTickets = true;
      }   
      this.fnCambiaFecha("", null);  
    }, 10);
  }

  fnCancelar(item){
    //console.log("cancelar: " + item.id)
    let dialogRef = this.dialog.open(CancelaTicketComponent, {
      width: "600px",
      data: { 
            id:item.id,
            item:item,
            grupo:this.agruparTickets
            }
    });
    dialogRef.afterClosed().subscribe(result => {
      //console.log("Popup cerrado");
      this.fnCargaReporte();
    }); 
  }

  fnElementosImpresionReciboCargados(idFormato, folio, folioFin, ticket){    
    var index = this.formato.findIndex(x => x.id === idFormato);
    var margins =this.formato[index].pageMargins.split(",");
    var height = 1.0;
    height = this.formato[index].lineHeight;
    var text = [];
    var text2 = [];
    var canvas = [];
    var images = [];  
    
    var auxLogo = <HTMLImageElement>document.getElementById("imgRepLogo");
    auxLogo.src = "../../../assets/logoBlack.png";
    this.dataService.fnWait(55);
    var auxProd = ticket;
    var auxLinea = [];
    var auxForma = [];
    var auxSubTot = [];
    var auxTot = 0;
    for(var l = 0; l < 13; l++){
      auxLinea[l] = "";
    }
    if(auxProd.idProd > 99990){
      for(var l = 0; l < auxProd.n; l++){
        //console.log(this.infoReciboTienda[l]);
        auxForma.push(this.infoReciboTienda[l].forma);
        auxSubTot.push(this.infoReciboTienda[l].tot);
        auxTot += this.infoReciboTienda[l].tot;
        var auxDesc = (this.infoReciboTienda[l].idDesc >= 0 ? '(' + this.dataService.findItemInObject(this.descs, this.infoReciboTienda[l].idDesc, "id").descuento + ')' : '');
        auxLinea[l] = "I" + auxProd.idGpo + "   " + this.dataService.fnLlenaEspacios(this.infoReciboTienda[l].forma.toUpperCase()+ " " + auxDesc, 55, "DESPUES") + "   " + this.dataService.fnLlenaEspacios(this.infoReciboTienda[l].qty.toString(), 4, "ANTES") + "  " + "    "+ "  " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(this.infoReciboTienda[l].tot), 12, "ANTES") + "  " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(this.infoReciboTienda[l].tot * (this.agruparTickets ? 1 : this.infoReciboTienda[l].qty) ,2), 12, "ANTES")
      }
    }

    var auxDesc = (ticket.idDesc >= 0 ? '(' + this.dataService.findItemInObject(this.descs, ticket.idDesc, "id").descuento + ')' : '');
    var auxDescPor=(ticket.idDesc >= 0 ?  ticket.descuento  : '');
    var arrSpecialStrings = [{
      'TITULO': ">> CSI <<",
      'RFC': this.dataService.sRFC,
      'CP': this.dataService.sCP,
      'DIR1': this.dataService.sDi,
      'DIR2': this.dataService.sDi2,
      'TEL': this.dataService.sT1,
      'FOLIO': auxProd.folioRec ? auxProd.folioRec : (folio != folioFin ? folio + " al " + folioFin : folio),
      //'FOLIO': folio != folioFin ? folio + " al " + folioFin : folio,
      'FECHAEMI': auxProd.fecha_emi + " " + auxProd.hora_emi,
      'AREA': auxProd.grupo.toUpperCase(),
      'CATEG': auxProd.categoria + "   [" + auxProd.fecha_emi + "]",
      'FORMA': auxLinea[0].length > 1 ? auxForma.filter(this.dataService.onlyUnique) : auxProd.forma,
      'LINEA1': auxLinea[0].length > 1 ? auxLinea[0] : "A" + auxProd.idGpo + "   " + this.dataService.fnLlenaEspacios(auxProd.prod.toUpperCase().replace("VISITA GUIADA", "VG") + " " + auxDesc, 55, "DESPUES") + "   " + this.dataService.fnLlenaEspacios(auxProd.n.toString(), 4, "ANTES") + "   " + this.dataService.fnLlenaEspacios(auxDescPor.toString(), 3, "ANTES") + "  " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(auxProd.subtot / (this.agruparTickets ? auxProd.n : 1)), 12, "ANTES") + "  " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(auxProd.tot * (this.agruparTickets ? 1 : auxProd.n) ,2), 12, "ANTES"),
      'LINEA2': auxLinea[1],
      'LINEA3': auxLinea[2],
      'LINEA4': auxLinea[3],
      'LINEA5': auxLinea[4],
      'LINEA6': auxLinea[5],
      'LINEA7': auxLinea[6],
      'LINEA8': auxLinea[7],
      'LINEA9': auxLinea[8],
      'LINEAA': auxLinea[9],
      'LINEAB': auxLinea[10],
      'LINEAC': auxLinea[11],
      'LINEAD': auxLinea[12],
      'LINEAE': "",
//      'TOTAL': "$ " + this.dataService.fnFormatMoney(auxProd.idProd > 99990 ? auxTot : (auxProd.tot * auxProd.n), 2),
//      'NUMASI_LETRA': this.dataService.fnLeeMonto(auxProd.idProd > 99990 ? auxTot : (auxProd.tot * auxProd.n)),
      'TOTAL': "$ " + this.dataService.fnFormatMoney(auxProd.idProd > 99990 ? auxTot : (auxProd.tot), 2),
      'NUMASI_LETRA': this.dataService.fnLeeMonto(auxProd.idProd > 99990 ? auxTot : (auxProd.tot)),
      'DESCUENTO': auxProd.aplicaDescuento
    }];
    var auxTxtMargen = [0,0,0,0];
    for(var i = 0; i < this.elemImp.length; i++){
      if(this.elemImp[i].tipo == "content"){
        if(this.elemImp[i].margin.indexOf(",") > 0)
          auxTxtMargen = this.elemImp[i].margin.split(",");
          auxTxtMargen = auxTxtMargen.map(function (x) {  
            return parseInt(x.toString(), 10); 
          }); 
        //console.log(auxTxtMargen);   --> NO FUNCIONAN MARGENES EN TEXTO
        text.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style: this.elemImp[i].style,
                    margin: [0,0,0,0],
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment
                  });                  
      }
      if(this.elemImp[i].tipo == "position"){
        text2.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style: this.elemImp[i].style,
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment,                              
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1])}
                  });                  
      }
      if(this.elemImp[i].tipo == 'image' && this.elemImp[i].dato == "ƒLOGO" ){
        images.push({
                    image:  this.dataService.fnGetBase64Image(auxLogo, auxLogo.naturalWidth, auxLogo.naturalHeight),
                    fit: [85, 30],
                    alignment: this.elemImp[i].alignment,
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1]) }
                   })
      }          
      if(this.elemImp[i].tipo == 'line'){
          canvas.push({
                      type: 'line',
                      r: 0,
                      x1: parseInt(this.elemImp[i].margin.split(",")[0]),
                      y1: parseInt(this.elemImp[i].margin.split(",")[1]),
                      x2: parseInt(this.elemImp[i].margin.split(",")[2]),
                      y2: parseInt(this.elemImp[i].margin.split(",")[3]),
                      lineColor: this.elemImp[i].color,
                      lineWidth: this.elemImp[i].alignment                               
                    })
      }
      if(this.elemImp[i].tipo == 'rect'){
        canvas.push({
                    type: 'rect',
                    r: 5,
                    fillOpacity: 0.3,
                    color: this.elemImp[i].style,
                    x: parseInt(this.elemImp[i].margin.split(",")[0]),
                    y: parseInt(this.elemImp[i].margin.split(",")[1]),
                    w: parseInt(this.elemImp[i].margin.split(",")[2]),
                    h: parseInt(this.elemImp[i].margin.split(",")[3]),
                    lineColor: this.elemImp[i].color,
                    lineWidth: this.elemImp[i].alignment                               
                  })
      }
    }

    var styles = this.elemStyle;
    var stack = [];
    if (this.formato[index].tipo == "TABLA")
      stack[0] = text;
    else
      stack.push({text:text});
    stack[1] = text2;
    stack.push({canvas:canvas});
    this.dd = {
      pageSize: this.formato[index].pageSize,
      pageOrientation: this.formato[index].pageOrientation,
      pageMargins: [parseInt(margins[0]), parseInt(margins[1]), parseInt(margins[2]), parseInt(margins[3])],
      content: [
        {
          lineHeight: 1.0,
          alignment: 'left',
          background: 'white',
          color: 'black',
          stack       
        }
        ,images   
      ],
      styles
    }
    pdfMake.createPdf(this.dd).open();
  }

  fnEditaForma(item:any){
    //console.log("editar: " + item.id)
    let dialogRef = this.dialog.open(EditaFormaComponent, {
      width: "600px",
      data: { 
            id:item.id,
            item:item,
            grupo:this.agruparTickets
            }
    });
    dialogRef.afterClosed().subscribe(result => {
      //console.log("Popup cerrado");
      this.fnCargaReporte();
    }); 
  }


}
